// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1KM8r","content":"LoadingAlert_content__x5f0S"};